<template>
  <div class="excellent_box" v-if="visible">
    <div class="excellent_main upload-spectrum-main">
      <div class="excellent_top">
        批量上传图谱
        <i class="el-icon-close" @click.stop="close"></i>
      </div>
      <div class="excellent_content">
        <div class="spectrum-upload-container">
          <div class="spectrum-upload-left">
            <el-button size="big" type="primary" @click="triggerFileSelect">选择图谱数据文件</el-button>
            <input ref="fileInput" type="file" accept=".txt" style="display: none" @change="onFileSelected"
                multiple />
            <div slot="tip" class="el-upload__tip">
              支持 txt 文本格式<br />
              文件名格式：品牌中文_型号中文_乙醇含量<br />
              一次不得上传超过100个文件<br />
            </div>
            <div style="margin: 80px 0; text-align: center;">
              <el-button type="success" size="big" :loading="loading"
                :disabled="!selectedFiles || selectedFiles.length === 0" @click="submitUpload">确定上传</el-button>
            </div>
          </div>
          <div class="spectrum-upload-right">
            <div v-if="selectedFiles && selectedFiles.length > 0" class="selected-files">
              <div class="files-header">已选择 {{ selectedFiles.length }} 个文件：</div>
              <div v-for="(file, index) in selectedFiles" :key="index" class="file-item">
                {{ file.name }}
              </div>
            </div>
            <div v-else class="no-files">暂未选择文件</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UploadSpectrum",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedFiles: [],
      loading: false
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.reset();
      }
    }
  },
  methods: {
    reset() {
      this.selectedFiles = [];
      this.loading = false;
    },

    close() {
      this.$emit("close");
    },

    triggerFileSelect() {
      this.$refs.fileInput.click();
    },

    onFileSelected(event) {
      const files = Array.from(event.target.files);
      if (!files || files.length === 0) return;

      // 验证文件类型（根据扩展名）
      const invalidFiles = files.filter(f => {
        const fileName = f.name || '';
        const ext = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
        return ext !== 'txt';
      });
      if (invalidFiles.length > 0) {
        this.$message.error('请选择文本格式文件（txt）');
        return;
      }

      this.selectedFiles = files;
    },

    submitUpload() {
      if (!this.selectedFiles || this.selectedFiles.length === 0) {
        this.$message.error('请选择要上传的文件');
        return;
      }

      this.loading = true;

      const formData = new FormData();
      // 将所有文件添加到 formData
      this.selectedFiles.forEach(file => {
        formData.append('files', file);
        formData.append('fileNames', file.name);
      });

      this.$https(this.$api.api.batchUploadTypeSpectrogram, formData, 'POST', {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then((res) => {
        this.loading = false;
        if (res.data.code == 200) {
          const data = res.data.data || {};
          const successCount = data.successCount || 0;
          const failCount = data.failCount || 0;

          if (failCount > 0) {
            this.$message.warning(`上传完成，成功 ${successCount} 条，失败 ${failCount} 条`);
            if (data.errorList && data.errorList.length > 0) {
              this.downloadErrorExcel(data.errorList);
            }
          } else {
            this.$message.success(`上传成功，共处理 ${successCount} 条`);
            this.$emit("success");
            this.close();
          }
        } else {
          this.$message.error(res.data.msg || '上传失败');
        }
      }).catch((err) => {
        this.loading = false;
        this.$message.error('上传失败：' + (err.message || '网络错误'));
      });
    },

    downloadErrorExcel(errorList) {
      this.$https(this.$api.api.exportUploadFileErrorExcel, errorList, 'FILE').then((res) => {
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = '图谱上传异常报告.xlsx';
        link.click();
        window.URL.revokeObjectURL(url);
        this.$emit("success");
        this.close();
      }).catch((err) => {
        this.$message.error('导出异常报告失败：' + (err.message || '网络错误'));
      });
    },
  }
};
</script>

<style lang="less" scoped>
.excellent_box {
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  background: rgba(000, 000, 000, 0.5);

  .excellent_main {
    width: 750px;
    max-height: 600px;
    margin: auto;
    background: #fff;
    transform: translate(-50%, -50%);
    position: fixed;
    left: 50%;
    top: 50%;
    border-radius: 5px;
    overflow: hidden;

    .excellent_top {
      width: 96%;
      height: 40px;
      background: #eee;
      line-height: 40px;
      padding: 5px 2%;
      font-size: 15px;

      i {
        float: right;
        margin-top: 10px;
        font-size: 20px;
        cursor: pointer;
      }
    }

    .excellent_content {
      padding: 15px;
      max-height: 420px;
      overflow-y: auto;

      .spectrum-upload-container {
        display: flex;

        .spectrum-upload-left {
          flex-shrink: 0;
          width: 250px;
          padding-top: 10px;

          .el-upload__tip {
            margin-top: 12px;
            font-size: 12px;
            color: #999;
            line-height: 1.5;
          }
        }

        .spectrum-upload-right {
          position: relative;
          flex: 1;
          min-height: 100px;
          max-height: 400px;
          overflow-y: auto;
          border: 1px solid #ddd;
          border-radius: 4px;
          padding: 10px;
          box-sizing: border-box;

          .selected-files {
            .files-header {
              font-weight: bold;
              margin-bottom: 8px;
              color: #409eff;
            }

            .file-item {
              font-size: 12px;
              color: #666;
              padding: 3px 0;
              word-break: break-all;
            }
          }

          .no-files {
            color: #999;
            text-align: center;
            line-height: 100px;
            font-size: 14px;
          }
        }
      }

    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/brand/uploadSpectrumModal.vue